// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ratisColoredText[data-v-6335a668]{color:#e10065}.redColoredText[data-v-6335a668]{color:red}.bold-text[data-v-6335a668]{font-weight:700}.orange-colored-text[data-v-6335a668]{color:orange}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
